/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Action": [
      "ApiCallAction",
      "ApiCallGraphqlAction",
      "CalculationAction",
      "ChecklistAction",
      "ClinicalNoteAction",
      "ExtensionAction",
      "FormAction",
      "MessageAction",
      "PushToEmrAction"
    ],
    "ExtensionActionField": [
      "BooleanField",
      "DateField",
      "HtmlField",
      "JsonField",
      "NumericArrayField",
      "NumericField",
      "StringArrayField",
      "StringField",
      "TextField"
    ],
    "PaginationAndSortingPayload": [
      "ActivitiesPayload"
    ],
    "Payload": [
      "ActionPayload",
      "ActivateTriggerPayload",
      "AddActionToStepPayload",
      "AddChecklistToStepPayload",
      "AddConditionToRulePayload",
      "AddConstantPayload",
      "AddDataPointDefinitionToPathwayPayload",
      "AddDataPointMappingToExtensionActionPayload",
      "AddDerivedDataPointDefinitionPayload",
      "AddLabelToStepPayload",
      "AddLocationToPathwayPayload",
      "AddMappingToApiCallPayload",
      "AddMessageToStepPayload",
      "AddQuestionToFormPayload",
      "AddQuestionsToFormPayload",
      "AddRuleToQuestionPayload",
      "AddStepFromLibraryToTrackPayload",
      "AddStepToLibraryPayload",
      "AddStepToTrackPayload",
      "AddStickyNoteToTrackPayload",
      "AddTrackToPathwayPayload",
      "AddTransformationToDynamicVariablePayload",
      "AddTriggerToPathwayPayload",
      "AddTriggerToTrackPayload",
      "AddWebhookPayload",
      "AgentPayload",
      "AgentsPayload",
      "AhpLinkPayload",
      "AhpLinkPayloads",
      "BaselineInfoPayload",
      "CalculationResultPayload",
      "CalculationsPayload",
      "CareflowComponentsPayload",
      "CheckpointPayload",
      "CheckpointsPayload",
      "ClearActionDueDatePayload",
      "ClearActionExpirationPayload",
      "ClearActionIdleTimePayload",
      "ClearTimingDelayPayload",
      "ClearTimingReferencePayload",
      "ClinicalNotePayload",
      "CodeBlockPayload",
      "CodeBlocksPayload",
      "ConfigureExtensionPayload",
      "ConnectStepsPayload",
      "ConstantPayload",
      "ConstantsPayload",
      "CreateDynamicVariablePayload",
      "CreateFormPayload",
      "CreateMessagePayload",
      "CreatePathwayCasePayload",
      "CreatePathwayPayload",
      "CreateTransitionPayload",
      "CreateTriggerPayload",
      "DataCatalogCollectionContextsPayload",
      "DataCatalogJsonPayload",
      "DataCatalogPayload",
      "DataPointDefinitionPayload",
      "DataPointDefinitionsPayload",
      "DecisionOutputsPayload",
      "DecisionTablePayload",
      "DecisionTablesPayload",
      "DeleteDecisionTablePayload",
      "DeleteLogicPayload",
      "DeletePathwayCasePayload",
      "DomainEventsPayload",
      "DuplicateCareflowPayload",
      "DuplicateFormPayload",
      "DuplicateQuestionPayload",
      "DuplicateStepPayload",
      "DynamicVariablePayload",
      "DynamicVariablesPayload",
      "EditRulePayload",
      "EditTriggerPayload",
      "ElementsPayload",
      "EmptyPayload",
      "EmrReportPayload",
      "EndTrackAfterStepPayload",
      "EvaluatedRulePayload",
      "ExecuteTestApiCallPayload",
      "ExtensionActivityRecordPayload",
      "ExtensionConfigurationsPayload",
      "ExtensionsPayload",
      "FileStorageConfigPayload",
      "FormPayload",
      "FormResponsePayload",
      "FormsPayload",
      "GeneratedClinicalNotePayload",
      "GeneratedEmrReportPayload",
      "GeneratedMessagePayload",
      "JsonPathPayload",
      "LocationsPayload",
      "LogicPayload",
      "LogicsPayload",
      "MakeFormSharedPayload",
      "MarkReleaseAsLivePayload",
      "MessagePayload",
      "OntologyNodePayload",
      "OntologyPayload",
      "PathwayCaseApiCallPayload",
      "PathwayCaseApiCallsPayload",
      "PathwayCasePayload",
      "PathwayCaseWebhookCallPayload",
      "PathwayCaseWebhookCallsPayload",
      "PathwayCasesPayload",
      "PathwayDiffPayload",
      "PathwayPayload",
      "PathwaySettingsPayload",
      "PathwayValidationStatusPayload",
      "PathwayVersionPayload",
      "PathwayVersionsPayload",
      "PathwaysPayload",
      "PreviewExtensionActionPayload",
      "PublishPathwayPayload",
      "ReadMessagePayload",
      "RebuildViewModelsPayload",
      "RefreshExtensionPayload",
      "RemoveActionFromStepPayload",
      "RemoveClinicalNoteNarrativePayload",
      "RemoveConditionFromRulePayload",
      "RemoveConstantPayload",
      "RemoveDataPointMappingFromExtensionActionPayload",
      "RemoveLabelsFromStepPayload",
      "RemoveMappingFromApiCallPayload",
      "RemoveQuestionFromFormPayload",
      "RemoveRuleFromQuestionPayload",
      "RemoveStepFromTrackPayload",
      "RemoveTrackFromPathwayPayload",
      "RemoveTransformationsFromDynamicVariablePayload",
      "RemoveTransitionPayload",
      "RemoveWebhookPayload",
      "ReorderActionsPayload",
      "ReorderQuestionsPayload",
      "RepairPathwaysPayload",
      "ResetPreviewPayload",
      "RetryWebhookCallPayload",
      "RulePayload",
      "SchemaPayload",
      "SetActionCalculationIdPayload",
      "SetActionCalculationInputPayload",
      "SetActionCalculationLanguagePayload",
      "SetActionChecklistItemsPayload",
      "SetActionDueDatePayload",
      "SetActionExpirationPayload",
      "SetActionFormDisplayModePayload",
      "SetActionFormIdPayload",
      "SetActionIdleTimePayload",
      "SetActionMessageIdPayload",
      "SetActionStakeholdersPayload",
      "SetActionTitlePayload",
      "SetApiCallBodyPayload",
      "SetApiCallEndpointPayload",
      "SetApiCallHeadersPayload",
      "SetApiCallMethodPayload",
      "SetBrandingAccentColorPayload",
      "SetBrandingCustomThemePayload",
      "SetBrandingHostedPageAutoProgressPayload",
      "SetBrandingHostedPageAutosavePayload",
      "SetBrandingHostedPageTitlePayload",
      "SetBrandingLogoUrlPayload",
      "SetCalculationPrerequisiteFormPayload",
      "SetConditionOperandPayload",
      "SetConditionOperatorPayload",
      "SetConditionReferencePayload",
      "SetCustomActionFieldPayload",
      "SetDataPointDefinitionMetaDataFieldPayload",
      "SetDataPointDefinitionOptionalFieldPayload",
      "SetDataPointDefinitionPiiFieldPayload",
      "SetDateQuestionConfigPayload",
      "SetDynamicVariableDataPointDefinitionPayload",
      "SetDynamicVariableDataPointPropertyPayload",
      "SetDynamicVariableFallbackPayload",
      "SetDynamicVariableLabelPayload",
      "SetExtensionActionDataPointMappingDataPointPayload",
      "SetExtensionActionDataPointMappingKeyPayload",
      "SetExtensionActionDataPointMappingsPayload",
      "SetExtensionActionErrorHandlingPayload",
      "SetExtensionActionFieldPayload",
      "SetFileQuestionConfigPayload",
      "SetFormKeyPayload",
      "SetFormMetadataPayload",
      "SetFormTitlePayload",
      "SetFormTrademarkPayload",
      "SetInputValidationQuestionConfigPayload",
      "SetLogicCoordinatesPayload",
      "SetMultipleSelectQuestionConfigPayload",
      "SetNumberQuestionConfigPayload",
      "SetPathwayCaseTitlePayload",
      "SetPathwayTitlePayload",
      "SetPhoneQuestionConfigPayload",
      "SetQuestionConfigPayload",
      "SetQuestionKeyPayload",
      "SetQuestionMetadataPayload",
      "SetQuestionOptionValueTypePayload",
      "SetQuestionsConfigPayload",
      "SetRemindersAmountPayload",
      "SetRemindersDelayPayload",
      "SetRuleBooleanOperatorPayload",
      "SetRuleTypePayload",
      "SetSliderQuestionConfigPayload",
      "SetStakeholderEmailsPayload",
      "SetStepCoordinatesPayload",
      "SetStepDocumentationPayload",
      "SetStepTitlePayload",
      "SetStickyNoteCoordinatesPayload",
      "SetTimingDelayPayload",
      "SetTimingReferencePayload",
      "SetTrackDescriptionPayload",
      "SetTrackEndCoordinatesPayload",
      "SetTrackLoopConfigurationPayload",
      "SetTrackStartCoordinatesPayload",
      "SetTrackTitlePayload",
      "SetTransformationParamsPayload",
      "SetTransformationTypePayload",
      "SetTransitionDestinationPayload",
      "StakeholdersPayload",
      "StartPreviewPayload",
      "StartTrackFromStepPayload",
      "StartTransitionFromStepPayload",
      "StepLibraryPayload",
      "StepPayload",
      "StepsPayload",
      "StickyNotePayload",
      "StickyNotesPayload",
      "SubmitChecklistPayload",
      "SubmitFormResponsePayload",
      "TenantPayload",
      "TenantsPayload",
      "TestSourceControlPayload",
      "TimerPayload",
      "TimersPayload",
      "TimingPayload",
      "TrackPayload",
      "TracksPayload",
      "TransitionPayload",
      "TransitionsPayload",
      "TriggerActivationPayload",
      "TriggerActivationsPayload",
      "TriggerApiCallPayload",
      "TriggerPayload",
      "UpdateApiCallMappingDataPointPayload",
      "UpdateApiCallMappingFirstMatchOnlyPayload",
      "UpdateApiCallMappingKeyPayload",
      "UpdateCareFlowApiCallRetrySettingsPayload",
      "UpdateCareFlowSourceControlSettingsPayload",
      "UpdateClinicalNoteContextPayload",
      "UpdateConstantPayload",
      "UpdateDataPointDefinitionPayload",
      "UpdateDynamicVariablePayload",
      "UpdateEmailNotificationStatusPayload",
      "UpdateLabelTextPayload",
      "UpdateQuestionPayload",
      "UpdateStickyNoteBodyPayload",
      "UpdateWebhookEndpointPayload",
      "UpdateWebhookHeadersPayload",
      "UpdateWebhookNamePayload",
      "UpdateWebhookPayload",
      "UpdateWebhookStatusPayload",
      "UpdateWebhookSubscribedEventsPayload",
      "UpdateWebhookTestEndpointPayload",
      "UserPayload",
      "WebhookPayload"
    ],
    "TimerConfig": [
      "DataPointAwaitedTimerConfig",
      "DataPointReferenceTimerConfig",
      "DelayTimerConfig",
      "ExtensionResourceUpdatedTimerConfig"
    ],
    "Transformation": [
      "AddDurationTransformation",
      "AddPrefixTransformation",
      "AddSuffixTransformation",
      "AddWeekdaysTransformation",
      "FormatDateTransformation",
      "FormatPhoneNumberTransformation",
      "RoundToTransformation",
      "SubtractDurationTransformation"
    ],
    "TriggerActivationReference": [
      "AdHocActivationReference",
      "DataPointCollectedActivationReference",
      "PathwayStartedActivationReference",
      "StepCompletedActivationReference",
      "TrackCompletedActivationReference",
      "TrackStartedActivationReference"
    ],
    "TriggerSettings": [
      "AdHocTriggerSettings",
      "DataPointCollectedTriggerSettings",
      "DataPointNotCollectedTriggerSettings",
      "DesignatedTriggerTimer",
      "EventBasedTriggerSettings",
      "ExtensionWebhookTriggerSettings",
      "PathwayStartedTriggerSettings",
      "StepCompletedTriggerSettings",
      "TrackCompletedTriggerSettings"
    ]
  }
};
      export default result;
    